import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function TerminosCondiciones() {
  const navigate = useNavigate();

  return (
    <div className="login-fondo">
      <div style={styles.container}>
        <div style={styles.header}>
          <img src="/img/BAC-MT.png" alt="BAC MT" style={{ width: '60px' }} />
          <h1 style={styles.titulo}>Términos y Condiciones</h1>
          <p style={styles.subtitulo}>BAC MT 2.0 — Sistema de Monitoreo</p>
        </div>

        <div style={styles.contenido}>
          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>1. Aceptación de los Términos</h2>
            <p style={styles.parrafo}>
              Al registrarse y utilizar el sistema BAC MT 2.0, usted acepta estos Términos y Condiciones en su totalidad. 
              Si no está de acuerdo con alguna parte de estos términos, no debe utilizar el servicio.
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>2. Descripción del Servicio</h2>
            <p style={styles.parrafo}>
              BAC MT 2.0 es una plataforma web de monitoreo en tiempo real para dispositivos de marcación y control 
              de kits empleados en estudios cardiológicos y neurológicos, desarrollada y operada por Laboratorios Bacon.
            </p>
            <p style={styles.parrafo}>
              El servicio permite:
            </p>
            <ul style={styles.lista}>
              <li>Visualización de registros de eventos en tiempo real</li>
              <li>Gestión de usuarios y permisos dentro de su organización</li>
              <li>Exportación de datos para análisis</li>
              <li>Monitoreo del estado de los equipos asignados</li>
            </ul>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>3. Registro y Cuenta de Usuario</h2>
            <p style={styles.parrafo}>
              Para utilizar el servicio, debe crear una cuenta proporcionando información precisa y actualizada. 
              Usted es responsable de mantener la confidencialidad de sus credenciales de acceso.
            </p>
            <p style={styles.parrafo}>
              En caso de olvido de contraseña, deberá comunicarse con Laboratorios Bacon para su restitución.
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>4. Uso Permitido</h2>
            <p style={styles.parrafo}>
              El usuario se compromete a utilizar el servicio únicamente para los fines previstos: monitoreo y 
              gestión de equipos médicos BAC MT. Queda prohibido:
            </p>
            <ul style={styles.lista}>
              <li>Intentar acceder a cuentas o datos de terceros</li>
              <li>Realizar ingeniería inversa del sistema</li>
              <li>Distribuir malware o código malicioso</li>
              <li>Utilizar el servicio para fines ilegales o no autorizados</li>
            </ul>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>5. Responsabilidad y Garantías</h2>
            <p style={styles.parrafo}>
              Laboratorios Bacon se esfuerza por mantener el servicio disponible y operativo, pero no garantiza 
              que el acceso será ininterrumpido o libre de errores. El servicio se proporciona "tal cual está".
            </p>
            <p style={styles.parrafo}>
              Laboratorios Bacon no se hace responsable por:
            </p>
            <ul style={styles.lista}>
              <li>Pérdida de datos debido a fallas de conectividad del cliente</li>
              <li>Decisiones médicas tomadas en base a los datos del sistema</li>
              <li>Daños indirectos o consecuentes derivados del uso del servicio</li>
            </ul>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>6. Protección de Datos Personales</h2>
            <p style={styles.parrafo}>
              El tratamiento de datos personales se rige por nuestra{' '}
              <span style={styles.link} onClick={() => navigate('/politica-privacidad')}>
                Política de Privacidad
              </span>
              {' '}y cumple con la Ley 25.326 de Protección de Datos Personales de la República Argentina.
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>7. Propiedad Intelectual</h2>
            <p style={styles.parrafo}>
              Todos los derechos de propiedad intelectual sobre el software, diseño, contenido y marcas del 
              sistema BAC MT 2.0 pertenecen a Laboratorios Bacon.
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>8. Modificaciones</h2>
            <p style={styles.parrafo}>
              Laboratorios Bacon se reserva el derecho de modificar estos términos en cualquier momento. 
              Los cambios entrarán en vigencia al ser publicados en la plataforma.
            </p>
          </section>

          <section style={styles.seccion}>
            <h2 style={styles.seccionTitulo}>9. Contacto</h2>
            <p style={styles.parrafo}>
              Para consultas sobre estos Términos y Condiciones, puede contactar a Laboratorios Bacon a través de 
              los medios de contacto proporcionados en el equipo o en nuestra página web.
            </p>
          </section>

          <p style={styles.fecha}>Última actualización: Mayo 2026</p>
        </div>

        <div style={styles.footer}>
          <button style={styles.btnVolver} onClick={() => navigate('/login')}>
            ← Volver al login
          </button>
          <p style={styles.copyright}>© 2026 Laboratorios Bacon</p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: '800px',
    margin: '40px auto',
    backgroundColor: 'var(--bg-card)',
    borderRadius: '12px',
    padding: '40px',
    border: '1px solid var(--border)',
  },
  header: {
    textAlign: 'center',
    marginBottom: '32px',
    paddingBottom: '24px',
    borderBottom: '1px solid var(--border)',
  },
  titulo: {
    fontSize: '1.8rem',
    fontWeight: '600',
    color: 'var(--text-primary)',
    marginTop: '16px',
    marginBottom: '8px',
  },
  subtitulo: {
    fontSize: '0.9rem',
    color: 'var(--text-muted)',
  },
  contenido: {
    lineHeight: '1.6',
  },
  seccion: {
    marginBottom: '28px',
  },
  seccionTitulo: {
    fontSize: '1.1rem',
    fontWeight: '600',
    color: 'var(--accent)',
    marginBottom: '12px',
  },
  parrafo: {
    fontSize: '0.9rem',
    color: 'var(--text-primary)',
    marginBottom: '12px',
  },
  lista: {
    fontSize: '0.9rem',
    color: 'var(--text-primary)',
    marginLeft: '24px',
    marginBottom: '12px',
  },
  link: {
    color: 'var(--accent)',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  fecha: {
    fontSize: '0.8rem',
    color: 'var(--text-muted)',
    fontStyle: 'italic',
    marginTop: '32px',
  },
  footer: {
    marginTop: '32px',
    paddingTop: '24px',
    borderTop: '1px solid var(--border)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  btnVolver: {
    background: 'none',
    border: '1px solid var(--border-light)',
    color: 'var(--text-muted)',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontFamily: 'IBM Plex Sans, sans-serif',
  },
  copyright: {
    fontSize: '0.8rem',
    color: 'var(--text-muted)',
  },
};

export default TerminosCondiciones;